
const color = localStorage.getItem('themecolor')

export const COLORS = {
    text: 'black',
    background: 'white',
    primary: "#8046fe",  //138FC2  '#292e57'
  };

